import React from 'react';
import classNames from 'classnames';

import EmojiImage from '../../EmojiImage';
import Button from '../../../buttons/Button';

import { getCompleteEmojiCode } from '../emojiPopupUtil';
import { Emoji } from '../../emojiTypes';

import './EmojiPopupEmojiButton.scss';

const BUTTON_PADDING = 14;

type EmojiPopupEmojiButtonProps = {
    emoji: Emoji;
    selected?: boolean;
    className?: string;
    skinTone?: string;
    gridSize?: number;
    emojiButtonSize?: number;
    onClickFn: () => void;
};

const EmojiPopupEmojiButton = ({
    className,
    emoji,
    selected,
    skinTone,
    emojiButtonSize,
    gridSize = 10,
    onClickFn,
}: EmojiPopupEmojiButtonProps) => {
    const emojiImageSize = emojiButtonSize ? emojiButtonSize - BUTTON_PADDING : gridSize * 2.4;

    const buttonStyle = emojiButtonSize ? { width: emojiButtonSize, height: emojiButtonSize } : {};
    return (
        <Button
            className={classNames('EmojiPopupEmojiButton', className, { selected })}
            onClickFn={onClickFn}
            style={buttonStyle}
        >
            <EmojiImage emojiCode={getCompleteEmojiCode(emoji, skinTone)} size={emojiImageSize} />
        </Button>
    );
};

export default EmojiPopupEmojiButton;
